import {
  BaseTable,
  Card,
  FooterMenu,
  HeaderMenu,
  Label,
  Loading,
  PaginationData,
  Select,
  TableHeader
} from "components"
import { createContext, useEffect, useState } from "react"
import { default_pagination_value } from "utils"
import { useDropdownEmployee } from "../CustomerOrder/utils/hooks/useDropdownEmployee"
import { useInvoiceList } from "../Invoice/utils/hooks/useInvoiceList"
import { RowApproveInvoice } from "./components"
import { APPROVAL_OPTIONS } from "./utils/vars"
import { FilterApprovalInvoice } from "./types"

type ContextApproveInvoiceProps = {
  refetchInvoice: () => void
}

export const ContextApproveInvoice = createContext<ContextApproveInvoiceProps>({
  refetchInvoice: () => { }
})

export default function ApproveInvoice() {
  const [pagination, setPagination] = useState<FilterApprovalInvoice>({
    ...default_pagination_value,
    size: 0,
    pages: 1,
    total: 0
  })
  const [searchData, setSearchData] = useState<number>(1)
  const { dropdown } = useDropdownEmployee()
  const { data, paginate, isLoading, refetch } = useInvoiceList({
    approval_status: searchData,
    page: pagination.page,
    limit: pagination.limit
  })

  useEffect(() => {
    setPagination((prev) => ({
      ...prev,
      size: paginate?.size ?? 0,
      pages: paginate?.pages ?? 1,
      total: paginate?.total ?? 0
    }))
  }, [paginate])

  return (
    <ContextApproveInvoice.Provider value={{ refetchInvoice: refetch }}>
      <section className="container my-2">
        <section>
          <HeaderMenu title="INVOICE APPROVAL" />

          <section>
            <section className="mt-2">
              <Card>
                <Card.Body>
                  <div className="justify-end flex items-center">
                    <Label className="mr-2">APPROVAL</Label>
                    <Select
                      className="lg:w-[200px]"
                      placeholder="Select Approval"
                      options={APPROVAL_OPTIONS}
                      value={APPROVAL_OPTIONS.find(
                        (item) => Number(item.value) === searchData
                      )}
                      onChange={(e) => setSearchData(Number(e?.value!))}
                    />
                  </div>
                </Card.Body>
              </Card>
            </section>
          </section>

          <section className="mt-2">
            <Card>
              <Card.Body>
                <div className="overflow-x-auto overflow-x-auto max-h-[calc(100vh-500px)]">
                  <BaseTable>
                    <TableHeader>
                      <tr>
                        <th>No</th>
                        <th colSpan={2}>INVOICE ID#</th>
                        <th>DATE</th>
                        <th>CUSTOMER</th>
                        <th>REF SO ID#</th>
                        <th>DELIVERY</th>
                        <th>LOCATION</th>
                        <th>MEMO</th>
                        <th>APPROVAL STATUS</th>
                        <th>APPROVAL DATE</th>
                      </tr>
                    </TableHeader>
                    <tbody>
                      {isLoading || !data?.length ? (
                        <tr>
                          <td colSpan={12} className="text-center">
                            <Loading
                              loading={isLoading}
                              errorText={isLoading ? "" : "No data available"}
                            />
                          </td>
                        </tr>
                      ) : (
                        data?.map((item, key) => {
                          return (
                            <RowApproveInvoice
                              key={item.invoice_id}
                              pagination={pagination}
                              employees={dropdown}
                              data={item}
                              index={key}
                            />
                          )
                        })
                      )}
                    </tbody>
                  </BaseTable>
                  <div className="mt-5">
                    <PaginationData
                      data={{
                        pagination_data: {
                          size: paginate?.size
                        }
                      }}
                      pagination={pagination}
                      setPagination={setPagination}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </section>

          <section className="mt-2">
            <FooterMenu />
          </section>
        </section>
      </section>
    </ContextApproveInvoice.Provider>
  )
}
